import { render, staticRenderFns } from "./WeighingSteps.vue?vue&type=template&id=71237c30&scoped=true"
import script from "./WeighingSteps.vue?vue&type=script&lang=js"
export * from "./WeighingSteps.vue?vue&type=script&lang=js"
import style0 from "./WeighingSteps.vue?vue&type=style&index=0&id=71237c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71237c30",
  null
  
)

export default component.exports